import { FC } from 'react';

import { Heart, Star } from 'lucide-react';
import { isEmpty, isNullish } from 'remeda';

import Chip from '@mui/material/Chip';

import css from './FavoriteSlots.module.css';

import { EmptyPlaceholder } from 'v2/components/emptyPlaceholder/EmptyPlaceholder';
import { ProfileCard } from 'v2/components/profileCard/ProfileCard';
import { FavoriteSlotDto } from 'v2/types/UserProfileModel';

interface FavoriteSlotsProps {
  slots?: FavoriteSlotDto[];
}

export const FavoriteSlots: FC<FavoriteSlotsProps> = ({ slots }) => (
  <ProfileCard icon={<Heart width={18} height={18} />} title="Favorite Slots">
    {isNullish(slots) || isEmpty(slots) ? (
      <EmptyPlaceholder />
    ) : (
      <div className={css.slotsContainer}>
        {slots.map((slot) => (
          <Chip
            key={slot.identifier}
            color="secondary"
            icon={<Star width={14} height={14} />}
            label={slot.title}
            variant="outlined"
          />
        ))}
      </div>
    )}
  </ProfileCard>
);
